import { render, staticRenderFns } from "./HandleDetail.vue?vue&type=template&id=7ee48ac2&scoped=true"
import script from "./HandleDetail.vue?vue&type=script&lang=js"
export * from "./HandleDetail.vue?vue&type=script&lang=js"
import style0 from "./HandleDetail.vue?vue&type=style&index=0&id=7ee48ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee48ac2",
  null
  
)

export default component.exports